import { render, staticRenderFns } from "./MarkLbl.vue?vue&type=template&id=b80215a6&scoped=true"
import script from "./MarkLbl.vue?vue&type=script&lang=js"
export * from "./MarkLbl.vue?vue&type=script&lang=js"
import style0 from "./MarkLbl.vue?vue&type=style&index=0&id=b80215a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80215a6",
  null
  
)

export default component.exports